import { LoadState } from "../../constants/enums";

export interface IEmailsState {
  emailsHistoryLog: {
    list: IEmailHistoryLog[];
    loading: LoadState;
    totalRecords: number;
  };
}

export interface IEmailHistoryLog {
  email_history_id: number;
  email_history_code: string | null;
  email_conversation_id: string | null;
  module_name: string | null;
  module_code: string | null;
  from_email: string | null;
  subject: string | null;
  to_mail_ids: string[];
  cc_mail_ids: string[];
  bcc_mail_ids: string[];
  body: {
    contentType: string | null;
    content: string | null;
  };
  attachments: string[] | null;
  comment: string | null;
  created_by_id: string | null;
  send_received_ts: string;
  create_ts: string;
  insert_ts: string;
}

export const initialEmailsState: IEmailsState = {
  emailsHistoryLog: {
    list: [],
    loading: LoadState.Loaded,
    totalRecords: 0,
  },
};
